import { HttpClient } from '@angular/common/http';
import { Injectable, } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  //Behavior Subject for Product Type
  private productType = new BehaviorSubject('');

  getProductType(): Observable<any> {
    return this.productType.asObservable();
  }

  setProductType(type) {
    this.productType.next(type);
  }

  //Behavior Subject for Product Category
  private productCategory = new BehaviorSubject('');

  getProductCategory(): Observable<any> {
    return this.productCategory.asObservable();
  }

  setProductCategory(cat) {
    this.productCategory.next(cat);
  }

  //Behavior Subject for Product Field
  private productField = new BehaviorSubject('');

  getProductField(): Observable<any> {
    return this.productField.asObservable();
  }

  setProductField(field) {
    this.productField.next(field);
  }

  //Behavior Subject for Product Visibility
  private productVisibility = new BehaviorSubject('');

  getProductVisibility(): Observable<any> {
    return this.productVisibility.asObservable();
  }

  setProductVisibility(cat) {
    this.productVisibility.next(cat);
  }

  //Behavior Subject for Product Tag
  private productTag = new BehaviorSubject('');

  getProductTag(): Observable<any> {
    return this.productTag.asObservable();
  }

  setProductTag(cat) {
    this.productTag.next(cat);
  }

  //Behavior Subject for UOM
  private uom = new BehaviorSubject('');

  getUOM(): Observable<any> {
    return this.uom.asObservable();
  }

  setUOM(field) {
    this.uom.next(field);
  }

  //Behavior Subject for Custom Field
  private custom = new BehaviorSubject('');

  getCustom(): Observable<any> {
    return this.custom.asObservable();
  }

  setCustom(field) {
    this.custom.next(field);
  }

  constructor(private http: HttpClient) { }

  getAllTypes() {
    return this.http.get<any>(`${environment.appOrgUrl}Type`)
  }

  loadISettings() {
    return this.http.get<any>(`${environment.inventoryURl}Product/InventorySettings`);
  }

  getProductVisibilityGroups() {
    return this.http.get<any>(`${environment.inventoryURl}ProductVisibility`);
  }

  addVisibilityGroup(value) {
    return this.http.post<any>(`${environment.inventoryURl}ProductVisibility`, value);
  }

  updateVisibilityGroup(value) {
    return this.http.put<any>(`${environment.inventoryURl}ProductVisibility`, value);
  }

  setDefaultVisibilityGroup(groupId) {
    return this.http.put<any>(`${environment.inventoryURl}ProductVisibility/SetDefault?id=${groupId}`, null);
  }

  deleteVisibilityGroup(id) {
    return this.http.delete<any>(`${environment.inventoryURl}ProductVisibility/${id}`);
  }

  getVisibilityRuleByGroupId(groupId: number, isAccount: boolean) {
    return this.http.get<any>(`${environment.inventoryURl}ProductVisibility/GetRulesByGroupId?groupId=${groupId}&isAccount=${isAccount}`);
  }

  addVisibilityData(value, fromAccount: boolean) {
    const url = (fromAccount ? 'Account' : 'Product');
    return this.http.post<any>(`${environment.inventoryURl}ProductVisibility/${url}`, value);
  }

  getProductColumnSettings(channelId: number): Observable<any> {
    return this.http.get(`${environment.inventoryURl}TrackingSetting/ProductFields?typeId=${channelId}`);
  }

}

